<template>
  <div
    class="reqpopup"
    :style="{ visibility: show ? 'unset' : 'hidden' }"
    ref="reqpop"
  >
    <!-- @mouseleave="close"> -->
    <div class="top">
      <div class="date" v-if="!!eventData">
        {{ this.$moment(eventData.start).format("dd, DD MMMM, HH:mm") }} -
        {{ this.$moment(eventData.end).format("HH:mm") }}
      </div>
      <button
        v-if="canEdit"
        @click="$emit('edit', { event: eventData, jsEvent })"
      >
        <img src="@/assets/images/icons/edit.svg" alt="" />
      </button>

      <button v-if="canDelete" @click="$emit('delete', eventData.id)">
        <img src="@/assets/images/icons/trash.svg" alt="" />
      </button>
      <button class="close" @click="close">
        <img src="@/assets/images/icons/close.svg" alt="" />
      </button>
    </div>
    <div class="person" v-if="master">
      <img v-if="master.avatar" :src="master.avatar" alt="" />
      <div>
        <div class="title">{{ master.name }} {{ master.surname }}</div>
        <div class="phone">{{ master.phone }}</div>
      </div>
    </div>
    <template v-if="rent">
      <template v-if="rent.invoice">
        <div>
          <div
            class="rent-button"
            v-if="!showInvoice"
            @click="showInvoice = true"
          >
            Показать информацию о счете
          </div>
          <div class="rent-button" v-else @click="showInvoice = false">
            Скрыть информацию о счете
          </div>
        </div>
        <transition name="fade">
          <div v-if="showInvoice" class="rent-invoice">
            <div class="item">
              <span class="title">Часов аренды: </span>
              <span class="description"
                >{{ rent.invoice.totalHours || 0 }} ч.</span
              >
            </div>
            <div class="item">
              <span class="title">Общая стоимость: </span>
              <span class="description"
                >{{ rent.invoice.total_sum || 0 }} ₽</span
              >
            </div>
            <div class="item" style="margin-top: 10px">
              <span class="title"
                >Пакеты часов ({{ rent.invoice.packageHours }} ч.):
              </span>
              <span class="description"
                >{{ rent.invoice.packageSum || 0 }} ₽</span
              >
            </div>
            <div class="item">
              <span class="title">Бонусы: </span>
              <span class="description">{{ rent.invoice.points || 0 }} ₽</span>
            </div>
            <div class="item">
              <span class="title">Приветственный бонус: </span>
              <span class="description"
                >{{ rent.invoice.bonusHours || 0 }} ч.</span
              >
            </div>

            <div class="item result">
              <span class="title" v-if="rent.invoice.isPaid">Оплачено: </span>
              <span class="title" v-else>Осталось к оплате: </span>
              <span class="description"
                >{{ rent.invoice.total_sum || 0 }} ₽</span
              >
            </div>
          </div>
        </transition>
      </template>

      <div class="payed" v-if="rent.payed">рабочее место оплачено</div>
      <div class="payed error" v-if="rent.error">рабочее место не оплачено</div>
      <div v-if="rent">
        <ButtonComponent
          v-if="
            !rent.payed &&
              !rent.not_come_at &&
              rent.start_work_at &&
              rent.end_work_at
          "
          @click="paid()"
          :loading="loading.paid"
          variant="filled"
          width="100%"
          mb="10px"
        >
          Оплатить рабочее место
        </ButtonComponent>
        <template v-if="rent.master">
          <ButtonComponent
            v-if="!rent.not_come_at && !rent.start_work_at"
            :loading="loading.startWork"
            @click="startWork()"
            variant="filled"
            width="100%"
            mb="10px"
          >
            Мастер приступил к работе
          </ButtonComponent>
          <ButtonComponent
            v-if="!rent.not_come_at && rent.start_work_at && !rent.end_work_at"
            :loading="loading.endWork"
            @click="endWork()"
            variant="filled"
            width="100%"
            mb="10px"
          >
            Мастер закончил работу
          </ButtonComponent>
          <ButtonComponent
            v-if="!rent.start_work_at && !rent.not_come_at"
            variant="outlined"
            width="100%"
            @click="notCome()"
            :loading="loading.notCome"
          >
            Мастер не пришел
          </ButtonComponent>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import moment from "moment";

export default {
  name: "RequestPopup",
  components: { ButtonComponent },
  data: () => ({
    show: false,
    eventData: null,
    jsEvent: null,
    showInvoice: false,
    loading: {
      paid: false,
      notCome: false,
      endWork: false,
      startWork: false,
    },
  }),
  computed: {
    rent() {
      return this.eventData && this.eventData.extendedProps
        ? this.eventData.extendedProps
        : null;
    },
    invoice() {
      return this.rent ? this.rent.invoice || null : null;
    },
    master() {
      return this.rent && this.rent.master
        ? this.eventData.extendedProps.master
        : null;
    },
    canDelete() {
      return (
        this.rent &&
        this.rent.end_at &&
        !this.rent.payed &&
        moment(this.rent.end_at) > moment()
      );
    },
    canEdit() {
      return (
        this.rent &&
        this.rent.end_at &&
        !this.rent.payed &&
        moment(this.rent.end_at) > moment()
      );
    },
  },
  methods: {
    endWork() {
      this.loading.endWork = true;
      this.$api.admin.rent
        .change(this.eventData.id, { end_work: true })
        .then(() => {
          this.$toast.success("Сохранено!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .finally(() => (this.loading.endWork = false));
    },
    notCome() {
      this.loading.notCome = true;
      this.$api.admin.rent
        .change(this.eventData.id, { not_come: true })
        .then(() => {
          this.$toast.success("Сохранено!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .finally(() => (this.loading.notCome = false));
    },
    startWork() {
      this.loading.startWork = true;
      this.$api.admin.rent
        .change(this.eventData.id, { start_work: true })
        .then(() => {
          this.$toast.success("Сохранено!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .finally(() => (this.loading.startWork = false));
    },
    paid() {
      this.loading.paid = true;
      this.$api.admin.rent
        .paid(this.eventData.id)
        .then(() => {
          this.$toast.success("Оплата аренды проведена успешно!");
          this.$eventHub.$emit("rent.changed");
          this.close();
        })
        .finally(() => (this.loading.paid = false));
    },
    close() {
      this.show = false;
      this.clear();
    },
    clear() {
      this.eventData = this.jsEvent = null;
    },
    open(e) {
      this.clear();
      //offsets section
      let w = this.$refs.reqpop.offsetWidth;
      let h = this.$refs.reqpop.offsetHeight;
      let left = Math.abs(
        e.jsEvent.x - e.jsEvent.layerX + e.jsEvent.target.clientWidth + w
      );
      let offset = 10;
      let lofSet = document.body.clientWidth - left;
      if (lofSet > 0) {
        lofSet = offset;
      } else {
        lofSet = -e.jsEvent.target.clientWidth - w - offset;
      }
      left -= w;
      let scrY = window.scrollY;
      if (
        document.body.offsetHeight <
        e.jsEvent.y - e.jsEvent.layerY + window.scrollY + h
      )
        scrY = -h + e.jsEvent.target.clientHeight + window.scrollY;
      //offsets end
      //coords section
      this.$refs.reqpop.style.left = left + lofSet + "px";
      this.$refs.reqpop.style.top =
        Math.abs(e.jsEvent.y - e.jsEvent.layerY + scrY) + "px";

      this.eventData = e.event;
      this.jsEvent = e.jsEvent;
      this.$emit("opened");
      this.show = true;
    },
  },
};
</script>

<style scoped lang="scss">
.rent-button {
  margin-bottom: 10px;
  text-decoration: underline;
  color: #383838;

  &:hover {
    cursor: pointer;
    color: #9e602a;
    transition: 0.3s;
  }
}

.rent-invoice {
  margin-bottom: 10px;
  padding: 5px 15px;
  border: 1px solid #dbbfa7;
  border-radius: 5px;

  & .title {
    font-size: 15px;
  }

  & .item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.result {
      margin-top: 10px;
      font-weight: 600;
    }
  }
}

.reqpopup {
  position: absolute;
  right: 0;
  top: 500px;
  max-width: 365px;
  width: 100%;
  border: 2px solid #dbbfa7;
  border-radius: 5px;
  background-color: #fff;
  padding: 15px 20px 20px 20px;
  z-index: 600;
}

.top {
  display: flex;
  margin-bottom: 15px;

  .date {
    margin-right: auto;
    font-size: 14px;
    line-height: 1.7;
    color: #808080;
  }

  button {
    border: none;
    background-color: transparent;
    margin-left: 10px;
    filter: grayscale(100%);
  }
}

.person {
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  img {
    margin-right: 10px;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 1px solid #dbbfa7;
    object-fit: cover;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;
  }

  .phone {
    font-size: 14px;
    line-height: 1.7;
    color: #808080;
  }
}

.payed {
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #0f8a84;
  margin-bottom: 15px;
}

.payed.error {
  color: darkred;
}

.close {
  width: 22px;
  height: 22px;

  img {
    width: 100%;
  }
}
</style>
